export const RsvpStatuses = {
  Yes: 'Yes',
  No: 'No',
  Maybe: 'Maybe',
  NotReplied: 'NotReplied',
} as const;

export type RsvpStatus = (typeof RsvpStatuses)[keyof typeof RsvpStatuses];
